import React, { Component } from 'react';
import './CustomMultiSelect.less';
import { MultiSelect } from 'primereact/multiselect';

class CustomMultiSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() { }

  componentDidUpdate(prevProps) { }

  formatDisplayValue = (selectedValues, options, label) => {
    if (!selectedValues || selectedValues.length === 0) {
      return `${label} (0)`;
    }

    if (selectedValues.length === 1) {
      const option = options.find(opt => opt.value === selectedValues[0] || opt === selectedValues[0]);
      return option ? (option.name || option.label || option) : selectedValues[0];
    }

    // return `${selectedValues.length}件選択されました`;
    return `${label} (${selectedValues.length})`;
  };

  render() {
    const { props } = this;
    const {
      hideLabel,
      label,
      className,
      value,
      options = [],
      placeholder,
      disabled,
      ...multiSelectProps
    } = props;

    const isDisabled = disabled || !options || options.length === 0;

    return (
      <div className={`custom-multiselect ${className ?? ''} ${isDisabled ? 'disabled' : ''}`}>
        {!hideLabel && <div className="multiselect-label">{`${label ?? 'Select'}`}</div>}
        <div className="multiselect-button-container">
          <MultiSelect
            {...multiSelectProps}
            value={value}
            options={options}
            className="custom-multiselect-input"
            placeholder={placeholder}
            display="comma"
            showClear={false}
            disabled={isDisabled}
          />
          <div className="multiselect-button-display">
            <span className="selected-text">
              {this.formatDisplayValue(value, options, label ?? 'Select')}
            </span>
            <svg
              className="dropdown-arrow"
              width="10"
              height="5"
              viewBox="0 0 10 5"
              fill="none"
            >
              <path
                d="M0 0L5 5L10 0"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    );
  }
}

CustomMultiSelect.propTypes = {};

export default CustomMultiSelect; 